import { useState } from 'react';

const useLoading = (initial = true): [boolean, (loading: boolean) => void] => {
  const [loading, setLoading] = useState(initial);

  return [loading, setLoading];
};

export default useLoading;
